export const config = {
    url: process.env.REACT_APP_APP_URL || 'https://my.adairhomes.com',
    port: process.env.PORT,
    api: {
        baseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost'
    },
}
